import React from 'react';
import { Input, TrashIcon } from '@avila-tek/ui/src';

interface CodeFormProps {
  codeInfo: string;
  setCodesArray: React.Dispatch<React.SetStateAction<string[]>>;
  index: number;
}

const CodeForm = ({ codeInfo, setCodesArray, index }: CodeFormProps) => {
  const handleCodeChange = (event) => {
    setCodesArray((prevCodes) => {
      if (prevCodes[index] !== event.target.value) {
        // Update only if different
        return [
          ...prevCodes.slice(0, index),
          event.target.value,
          ...prevCodes.slice(index + 1),
        ];
      }
      return prevCodes; // No change, return original array to prevent unnecessary re-render
    });
  };

  const deleteCode = () => {
    setCodesArray((prevCodes) =>
      prevCodes.filter((_, codeIndex) => codeIndex !== index)
    );
  };

  return (
    <div className="relative text-danger-200">
      <Input
        name={`code-${index}`}
        label="Código"
        type="text"
        value={codeInfo}
        placeholder="Ingrese código"
        className=""
        onChange={handleCodeChange}
      />
      <TrashIcon
        className="w-6 h-6 absolute top-8 right-3 z-30 cursor-pointer"
        onClick={deleteCode}
      />
    </div>
  );
};

export default CodeForm;
